import store from "../../store";
import {
  fetchTableFieldRows,
  tableAPILinkUnlinkService,
  updateTableAPICellService,
  updateTableAPIColService,
  tableAddRowService,
  tableRemoveRowService,
  tableAddColService,
  tableAPITypeChangeService,
  tableRemoveColService,
  tableRowUpdateService,
  tableReorderColumnService,
  tableMetaUpdateService,
  tableBatchCellsUpdateService,
} from "./services";

export const updateTableFieldRowsAction = (tableId, rows) => dispatch => {
  dispatch({
    type: "UPDATE_TABLE_FIELDS_ROWS",
    payload: {
      tableId,
      rows,
    },
  });
};

export const fetchAndUpdateTableRows = tableId => dispatch =>
  new Promise((resolve, reject) => {
    fetchTableFieldRows(tableId)
      .then(res => {
        dispatch(updateTableFieldRowsAction(tableId, res.TableRows));
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableAPILinkUnlink = (docId, fieldId, action) => dispatch =>
  new Promise((resolve, reject) => {
    tableAPILinkUnlinkService(docId, fieldId, action)
      .then(res => {
        dispatch({
          type: "UPDATE_TABLE_API_FIELD",
          payload: {
            field: res.Field,
            tableAPIType:
              action === "link" ? "linked_table_id" : "unlinked_table_id",
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableAPITypeChange =
  (tableId, clauseField, action, componentId) => dispatch =>
    new Promise((resolve, reject) => {
      tableAPITypeChangeService(tableId, action)
        .then(res => {
          dispatch({
            type: "UPDATE_TABLE_API_TYPE",
            payload: {
              tableId,
              tableType: res.Table.table_type,
              clauseField,
              componentId,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const tableAddRow =
  (tableId, prevId, action, insertRowAfter, clauseField) => dispatch =>
    new Promise((resolve, reject) => {
      const payload = {
        prev_id: prevId,
      };
      tableAddRowService(tableId, action, payload)
        .then(res => {
          dispatch({
            type: "TABLE_ADD_ROW",
            payload: {
              rowData: res.RowData,
              tableId,
              insertRowAfter,
              clauseField,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const tableDeleteRow =
  (tableId, prevId, currId, action, deleteRowAt, clauseField) => dispatch =>
    new Promise((resolve, reject) => {
      const payload = {
        row_id: currId,
        prev_id: prevId,
      };
      tableRemoveRowService(tableId, action, payload)
        .then(res => {
          dispatch({
            type: "TABLE_DELETE_ROW",
            payload: {
              tableId,
              deleteRowAt,
              clauseField,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const tableDeleteCol =
  (tableId, currId, action, clauseField) => dispatch =>
    new Promise((resolve, reject) => {
      const payload = {
        col_id: currId,
      };
      tableRemoveColService(tableId, action, payload)
        .then(res => {
          dispatch({
            type: "TABLE_DELETE_COL",
            payload: {
              tableData: res.Table,
              tableId,
              currId,
              clauseField,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const tableAddCol =
  (tableId, prevId, action, insertColAt, clauseField) => dispatch =>
    new Promise((resolve, reject) => {
      const payload = {
        prev_id: prevId,
        cell_meta: {},
        rich: {},
        text: "",
      };
      tableAddColService(tableId, action, payload)
        .then(res => {
          dispatch({
            type: "TABLE_ADD_COL",
            payload: {
              tableData: res.Table,
              tableId,
              insertColAt,
              addedCellData: {
                cell_meta: {},
                rich: {},
                text: "",
              },
              clauseField,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const tableRowUpdate =
  (tableId, action, updatedRow, updateRowAt, clauseField) => dispatch =>
    new Promise((resolve, reject) => {
      const payload = updatedRow;
      tableRowUpdateService(tableId, action, payload)
        .then(res => {
          dispatch({
            type: "TABLE_ROW_UPDATE",
            payload: {
              rowData: res.RowData,
              tableId,
              updateRowAt,
              clauseField,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const tableMetaUpdate =
  (tableId, action, updatedTableMeta, dynamicFieldId) => dispatch =>
    new Promise((resolve, reject) => {
      const { tables } = store.getState().DocumentStore;
      const currTableData = tables.find(table => table.table_id === tableId);
      const payload = {
        table_meta: { ...currTableData.table_meta, ...updatedTableMeta },
      };
      tableMetaUpdateService(tableId, action, payload)
        .then(res => {
          dispatch({
            type: "TABLE_META_UPDATE",
            payload: {
              tableId,
              dynamicFieldId,
              appendTableMeta: {
                ...currTableData.table_meta,
                ...updatedTableMeta,
              },
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const tableReorderColumn =
  (tableId, action, reorderdCols, dynamicFieldId) => dispatch =>
    new Promise((resolve, reject) => {
      const payload = reorderdCols;
      tableReorderColumnService(tableId, action, payload)
        .then(res => {
          dispatch({
            type: "TABLE_REORDER_COLUMN_UPDATE",
            payload: {
              columnOrder: res.ColumnOrder,
              tableId,
              dynamicFieldId,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const updateTableAPICellData =
  ({ tableFieldId, text, rich, cellId, rowId, cellMeta }) =>
  dispatch =>
    new Promise((resolve, reject) => {
      const payload = {
        row_id: rowId,
        row_data: {
          [cellId]: {
            text,
            rich,
            cell_meta: cellMeta || {},
          },
        },
      };
      updateTableAPICellService(tableFieldId, payload)
        .then(res => {
          dispatch({
            type: "UPDATE_UNLINKED_TABLE_API_CELL_DATA",
            payload: {
              tableFieldId,
              rowId,
              cellId,
              cellData: {
                text,
                rich,
                cell_meta: cellMeta || {},
              },
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const updateTableAPIColData =
  ({ tableFieldId, text, rich, cellId, cellMeta }) =>
  dispatch =>
    new Promise((resolve, reject) => {
      const payload = {
        col_id: cellId,
        cell_meta: cellMeta || {},
        rich,
        text,
      };
      updateTableAPIColService(tableFieldId, payload)
        .then(res => {
          dispatch({
            type: "UPDATE_UNLINKED_TABLE_API_COL_DATA",
            payload: {
              tableFieldId,
              cellId,
              cellData: {
                text,
                rich,
                cell_meta: cellMeta || {},
              },
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const tableBatchCellsUpdate =
  (tableId, action, updatedTableCells, dynamicFieldId) => dispatch =>
    new Promise((resolve, reject) => {
      const payload = updatedTableCells;
      tableBatchCellsUpdateService(tableId, action, payload)
        .then(res => {
          dispatch({
            type: "TABLE_BATCH_CELLS_UPDATE",
            payload: {
              tableId,
              tableRows: res.TableRows,
              dynamicFieldId,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
